const pageNameKey = "replaceBlueprintModal";

export const replaceBlueprintModalEn = {
  [pageNameKey]: {
    successMessage: "Blueprint has been successfully updated.",
    errorMessage: "Failed to update Blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Unable to update Blueprint: nodeset size exceeds maximum number of nodes (50000).",
    subTitle: "Replace Blueprint",
    warningIconAltText: "Warning Icon - already existing Blueprint",
    warningText: "This Blueprint already exists!",
    blueprintIconAltText: "Blueprint Icon",
    dateAndAuthorTemplate: "{date} by {author}",
    blueprintReplaceQuestion: "Do you want to replace it?",
    firstBlueprintReplacementDescriptionParagraph:
      "A blueprint with the same name already exists in your library. Replacing it will overwrite its current contents.",
    secondBlueprintReplacementDescriptionParagraph:
      "Structures that already used this blueprint in the past will not be affected.",
    continueButton: "Continue and replace",
    cancelButton: "Cancel",
  },
};

export const replaceBlueprintModalPtBr = {
  [pageNameKey]: {
    successMessage: "O blueprint foi atualizado com sucesso.",
    errorMessage: "Falha ao atualizar o Blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Não foi possível atualizar o Blueprint: o tamanho do conjunto de nós excede o número máximo de nós (50000).",
    subTitle: "Substituir blueprint",
    warningIconAltText: "Ícone de aviso - Blueprint já existente",
    warningText: "Este Blueprint já existe!",
    blueprintIconAltText: "Ícone do desenho técnico",
    dateAndAuthorTemplate: "{date} por {author}",
    blueprintReplaceQuestion: "Deseja substituí-lo?",
    firstBlueprintReplacementDescriptionParagraph:
      "Já existe um blueprint com esse nome na sua biblioteca. Ao substituí-lo, o conteúdo atual será sobrescrito.",
    secondBlueprintReplacementDescriptionParagraph:
      "Estruturas que já usaram este modelo no passado não serão afetadas.",
    continueButton: "Continuar e substituir",
    cancelButton: "Cancelar",
  },
};

export const replaceBlueprintModalDe = {
  [pageNameKey]: {
    successMessage: "Blueprint wurde erfolgreich aktualisiert.",
    errorMessage: "Fehler beim Aktualisieren des Blueprints",
    errorNodeStructureForBlueprintTooManyNodes:
      "Blueprint kann nicht aktualisiert werden: Knotenanzahl überschreitet die maximale Anzahl von Knoten (50000).",
    subTitle: "Blueprint ersetzen",
    warningIconAltText: "Warnsymbol - bereits vorhandener Blueprint",
    warningText: "Dieser Blueprint existiert bereits!",
    blueprintIconAltText: "Blueprint Symbol",
    dateAndAuthorTemplate: "{date} von {author}",
    blueprintReplaceQuestion: "Möchten Sie ihn ersetzen?",
    firstBlueprintReplacementDescriptionParagraph:
      "Ein Blueprint mit dem gleichen Namen existiert bereits in Ihrer Bibliothek. Durch das Ersetzen wird sein aktueller Inhalt überschrieben.",
    secondBlueprintReplacementDescriptionParagraph:
      "Strukturen, die diesen Blueprint in der Vergangenheit verwendet haben, werden nicht beeinträchtigt.",
    continueButton: "Fortfahren und ersetzen",
    cancelButton: "Abbrechen",
  },
};

export const replaceBlueprintModalZhHans = {
  [pageNameKey]: {
    successMessage: "Blueprint 已成功更新。",
    errorMessage: "更新 Blueprint 失败",
    errorNodeStructureForBlueprintTooManyNodes:
      "无法更新 Blueprint：节点集大小超过最大节点数（50000）。",
    subTitle: "替换 Blueprint",
    warningIconAltText: "警告图标 - 已存在的 Blueprint",
    warningText: "此 Blueprint 已存在！",
    blueprintIconAltText: "Blueprint 图标",
    dateAndAuthorTemplate: "{date} 由 {author} 提供",
    blueprintReplaceQuestion: "您想替换它吗？",
    firstBlueprintReplacementDescriptionParagraph:
      "您的库中已经存在同名的 Blueprint。替换它将覆盖其当前内容。",
    secondBlueprintReplacementDescriptionParagraph:
      "过去曾使用此 Blueprint 的结构将不受影响。",
    continueButton: "继续并替换",
    cancelButton: "取消",
  },
};

export const replaceBlueprintModalIt = {
  [pageNameKey]: {
    successMessage: "Il Blueprint è stato aggiornato con successo.",
    errorMessage: "Impossibile aggiornare il Blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Impossibile aggiornare il Blueprint: la dimensione del nodeset supera il numero massimo di nodi (50000).",
    subTitle: "Sostituisci Blueprint",
    warningIconAltText: "Icona di avviso - Blueprint già esistente",
    warningText: "Questo Blueprint esiste già!",
    blueprintIconAltText: "Icona Blueprint",
    dateAndAuthorTemplate: "{date} di {author}",
    blueprintReplaceQuestion: "Vuoi sostituire il Blueprint?",
    firstBlueprintReplacementDescriptionParagraph:
      "Un Blueprint con lo stesso nome esiste già nella tua libreria. Quest'azione sovrascriverà i suoi contenuti attuali.",
    secondBlueprintReplacementDescriptionParagraph:
      "Le strutture su cui è stato utilizzato questo Blueprint in passato non saranno interessate, l'azione non è retroattiva.",
    continueButton: "Continua e sostituisci",
    cancelButton: "Annulla",
  },
};

export const replaceBlueprintModalEs = {
  [pageNameKey]: {
    successMessage: "El plano se ha actualizado correctamente.",
    errorMessage: "No se pudo actualizar Blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "No se puede actualizar Blueprint: el tamaño del conjunto de nodos supera el número máximo de nodos (50000).",
    subTitle: "Reemplazar plano",
    warningIconAltText: "Icono de advertencia - plano ya existente",
    warningText: "¡Este plano ya existe!",
    blueprintIconAltText: "Icono de plano",
    dateAndAuthorTemplate: "{date} por {author}",
    blueprintReplaceQuestion: "¿Quieres reemplazarlo?",
    firstBlueprintReplacementDescriptionParagraph:
      "Ya existe un plano con el mismo nombre en tu biblioteca. Si lo reemplazas, se sobrescribirá su contenido actual.",
    secondBlueprintReplacementDescriptionParagraph:
      "Las estructuras que ya utilizaron este plano en el pasado no se verán afectadas.",
    continueButton: "Continuar y reemplazar",
    cancelButton: "Cancelar",
  },
};

export const replaceBlueprintModalNl = {
  [pageNameKey]: {
    blueprintIconAltText: "Blueprint-pictogram",
    blueprintReplaceQuestion: "Wilt u deze vervangen?",
    cancelButton: "Annuleren",
    continueButton: "Doorgaan en vervangen",
    dateAndAuthorTemplate: "{date} door {author}",
    errorMessage: "bewerken van blueprint mislukt",
    errorNodeStructureForBlueprintTooManyNodes:
      "Kan blueprint niet bewerken: nodeset-grootte overschrijdt het maximale aantal nodes (50000).",
    firstBlueprintReplacementDescriptionParagraph:
      "Er bestaat al een blueprint met dezelfde naam in uw bibliotheek. Als u deze vervangt, wordt de huidige inhoud overschreven.",
    secondBlueprintReplacementDescriptionParagraph:
      "Structuren die deze blueprint in het verleden al hebben gebruikt, worden niet beïnvloed.",
    subTitle: "Blueprint vervangen",
    successMessage: "Blueprint is succesvol bijgewerkt.",
    warningIconAltText: "Waarschuwingspictogram - reeds bestaande blueprint",
    warningText: "Deze blueprint bestaat al!",
  },
};

export const replaceBlueprintModalTr = {
  [pageNameKey]: {
    blueprintIconAltText: "Plan Simgesi",
    blueprintReplaceQuestion: "Değiştirmek istiyor musunuz?",
    cancelButton: "İptal etmek",
    continueButton: "Devam et ve değiştir",
    dateAndAuthorTemplate: "{author} tarafından {date}",
    errorMessage: "Blueprint güncellenemedi",
    errorNodeStructureForBlueprintTooManyNodes:
      "Blueprint güncellenemiyor: düğüm kümesi boyutu maksimum düğüm sayısını (50000) aşıyor.",
    firstBlueprintReplacementDescriptionParagraph:
      "Kitaplığınızda aynı ada sahip bir plan zaten mevcut. Bunu değiştirmek mevcut içeriğinin üzerine yazacaktır.",
    secondBlueprintReplacementDescriptionParagraph:
      "Bu planı geçmişte kullanmış olan yapılar etkilenmeyecektir.",
    subTitle: "Planı Değiştir",
    successMessage: "Blueprint başarıyla güncellendi.",
    warningIconAltText: "Uyarı Simgesi - zaten mevcut Plan",
    warningText: "Bu Taslak zaten mevcut!",
  },
};
